import React from 'react';
import { fillPriceLabel, fillVolumeLabel } from '../legend/labels';
import TimeSeriesLegend from 'utils/components/TimeSeriesChart/TimeSeriesLegend';
import {
    FillsChartType,
    toggleConfigProperty,
} from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import { WidgetLegend } from 'widgets/WidgetLegend/WidgetLegend';
import { UseToggleConfigOptionRet } from 'widgets/store/configuration/configSlice';
import { useFillsGraphConfigurationSelector } from 'widgets/fillsGraph/store/configuration/selectors';
import { useDispatchUpdateFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/dispatcher';

export interface OrderFillsChartMultiLegendProps {
    fillPrice: string | undefined;
    fillVolume: string | undefined;
    fillsGraphContainerLeft: number;
}

export function OrderFillsChartMultiLegend(
    props: OrderFillsChartMultiLegendProps
) {
    const { fillPrice, fillVolume, fillsGraphContainerLeft } = props;

    const config = useFillsGraphConfigurationSelector();
    const updateConfig = useDispatchUpdateFillsGraphConfiguration();

    const toggleFillPriceLegendVisible = () =>
        updateConfig(
            toggleConfigProperty(
                config,
                FillsChartType.OrderFills,
                'hideFillPriceLegend'
            )
        );
    const fillPriceLegendHidden = !!config['OrderFills'].hideFillPriceLegend;
    const toggleFillPriceLegendVisibleConfigOption: UseToggleConfigOptionRet = {
        value: fillPriceLegendHidden,
        toggle: toggleFillPriceLegendVisible,
    };

    const toggleFillVolumeLegendVisible = () =>
        updateConfig(
            toggleConfigProperty(
                config,
                FillsChartType.OrderFills,
                'hideFillVolumeLegend'
            )
        );
    const fillVolumeLegendHidden = !!config['OrderFills'].hideFillVolumeLegend;
    const toggleFillVolumeLegendVisibleConfigOption: UseToggleConfigOptionRet =
        {
            value: fillVolumeLegendHidden,
            toggle: toggleFillVolumeLegendVisible,
        };

    return (
        <div className="fill-legend">
            <div className={'OrderFillsChartMultiLegend'}>
                <WidgetLegend
                    toggleLegendVisibleConfigOption={
                        toggleFillPriceLegendVisibleConfigOption
                    }
                >
                    <TimeSeriesLegend
                        className="fill-price"
                        label={fillPriceLabel}
                        containerLeft={fillsGraphContainerLeft}
                        value={fillPrice === undefined ? '-' : fillPrice}
                    />
                </WidgetLegend>
                <WidgetLegend
                    toggleLegendVisibleConfigOption={
                        toggleFillVolumeLegendVisibleConfigOption
                    }
                >
                    <TimeSeriesLegend
                        className="fill-volume"
                        containerLeft={fillsGraphContainerLeft}
                        label={fillVolumeLabel}
                        value={fillVolume === undefined ? '-' : fillVolume}
                    />
                </WidgetLegend>
            </div>
        </div>
    );
}
